module.exports = __webpack_public_path__ + "static/media/GY.2ecaea30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GY.svg
// module id = 2166
// module chunks = 7